export default __webpack_public_path__ + "assets/38be83efa23cad294b14094ec074cbd2.woff2";